import React from 'react';
import './Pagination.css'

const ITEMS_PER_PAGE = 50; 

const Pagination = ({ totalItems, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  if (totalPages <= 1) return null; 

  const getPageNumbers = () => {
    // Logic to determine which page buttons to show (e.g., max 5 at once)
    const maxButtons = 5;
    let start = Math.max(1, currentPage - Math.floor(maxButtons / 2));
    let end = Math.min(totalPages, start + maxButtons - 1);

    if (end - start + 1 < maxButtons) {
      start = Math.max(1, end - maxButtons + 1);
    }
    
    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderTop: '1px solid #ccc' }}>
      <div style={{ fontSize: '14px', color: '#666' }}>
        Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1} to {Math.min(currentPage * ITEMS_PER_PAGE, totalItems)} of {totalItems} entries
      </div> 
     
      <div style={{ display: 'flex', gap: '5px' }}>
        <button
          className="page-button page-button-nav"
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
        >
          First
        </button>

        <button
          className="page-button page-button-nav"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        
        {getPageNumbers().map(page => (
          <button
            className="page-button page-button-nav"
            key={page}
            onClick={() => onPageChange(page)}
            style={{ fontWeight: page === currentPage ? 'bold' : 'normal', backgroundColor: page === currentPage ? '#ddd' : 'white' }}
          >
            {page}
          </button>
        ))}

        <button
          className="page-button page-button-nav"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>

        <button
          className="page-button page-button-nav"
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          Last
        </button>
      </div>
    </div>
  );
};

export default Pagination;